
angular.module('mtic.components.modules.bubbleModule',[]).component('bubbleModule', {
  templateUrl: 'template.html',
  bindings: {
    moduleMapData: '<'
  },
  controllerAs: 'bubbleModule',
  controller: function(EventManager, $scope) {
    var eventManager = new EventManager('bubbleModule', $scope);
    var bubbleModule = this;

  }
})
